const UPDATE = 'modules/manageAuthButtonStatus/UPDATE';

const reducer = (state = 'login', action) => {
  switch (action.type) {
    case UPDATE:
      return action.button;
    default:
      return state;
  }
};

const updateAuthButtonStatus = button => {
  return {
    button,
    type: UPDATE,
  };
};

export { reducer as default, updateAuthButtonStatus };
